import * as classNames from "classnames"

export const useTexts = (isEnvironmentCamera) => {
	const maskText = isEnvironmentCamera
		? "Posicione seu documento na área indicada"
		: "Posicione seu rosto na área indicada"
	
	const componentClass = classNames("app-camera", {
		"app-camera--back": isEnvironmentCamera,
	})
	return {
		maskText, 
		componentClass
	}
}